import React from 'react';
import { useBudgetManagerClusters } from '@domain/budget-manager/budget-manager-clusters.hook';
import { useLoggedUser } from '@domain/logged-user';
import SwitchButton from '../../../../shared/components/inputs/buttons/SwitchButton';
import {
    getStatusByAutomation, isTotalColumn, isUntagged, isFieldLoading,
} from './campaign-table-cluster.utils';
import { getClusterByName } from '../cluster.utils';
import { ClusterSwitchLoading, ClusterSwitchWrapper } from './campaign-table-cluster-styles';
import ColorConstants from '../../../../shared/constants/ColorConstants';

interface ClusterSwitchData {
    row: any
    isBudgetManager: boolean,
    isBidManager: boolean,
}

export const ClusterSwitch = ({
    isBudgetManager,
    isBidManager,
    row,
}: ClusterSwitchData) => {
    const {
        clusters, updateCluster, updatedCluster, updatedClusterState,
    } = useBudgetManagerClusters();
    const { loggedUser } = useLoggedUser();
    const { values: { cluster_name: clusterName = '' } } = row;
    const cluster = getClusterByName(clusters, clusterName);

    if (isTotalColumn(clusterName) || isUntagged(clusterName)) return null;

    if (isFieldLoading({
        cluster, updatedCluster, updatedClusterState,
    })) {
        return <ClusterSwitchLoading />;
    }

    const checked = getStatusByAutomation(cluster, isBudgetManager, isBidManager);

    const onChange = () => {
        updateCluster({
            clusterId: cluster.id,
            organizationId: cluster.organizationId,
            userId: loggedUser.id,
            cluster: {
                ...cluster,
                isBudgetActive: isBudgetManager
                    ? !cluster.isBudgetActive : cluster.isBudgetActive,
                isTargetActive: isBidManager
                    ? !cluster.isTargetActive : cluster.isTargetActive,
            },
        });
    };

    return (
        <ClusterSwitchWrapper>
            <SwitchButton
                checked={checked}
                onChange={onChange}
                disabledBackground={ColorConstants.salmon}
                enabledBackground={ColorConstants.padua}
            />
        </ClusterSwitchWrapper>
    );
};
